import * as client_hooks from '../../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37')
];

export const server_loads = [];

export const dictionary = {
		"/": [3],
		"/(app)/case-files/[id]": [4,[2]],
		"/(app)/companies": [5,[2]],
		"/(app)/companies/create": [7,[2]],
		"/(app)/companies/[id]": [6,[2]],
		"/(app)/creditors": [8,[2]],
		"/(app)/creditors/create": [10,[2]],
		"/(app)/creditors/[id]": [9,[2]],
		"/(app)/dashboard": [11,[2]],
		"/(app)/email-templates": [12,[2]],
		"/(app)/email-templates/create": [14,[2]],
		"/(app)/email-templates/[id]": [13,[2]],
		"/(app)/exports": [15,[2]],
		"/(app)/exports/create": [17,[2]],
		"/(app)/exports/[id]": [16,[2]],
		"/(app)/ledger": [18,[2]],
		"/(app)/ledger/agents/[id]": [19,[2]],
		"/login": [37],
		"/(app)/merchants": [20,[2]],
		"/(app)/merchants/create": [22,[2]],
		"/(app)/merchants/[id]": [21,[2]],
		"/(app)/my-case-files": [23,[2]],
		"/(app)/organizations": [24,[2]],
		"/(app)/organizations/create": [26,[2]],
		"/(app)/organizations/[id]": [25,[2]],
		"/(app)/profile": [27,[2]],
		"/(app)/scripts": [28,[2]],
		"/(app)/scripts/create": [30,[2]],
		"/(app)/scripts/[id]": [29,[2]],
		"/(app)/teams": [31,[2]],
		"/(app)/teams/create": [33,[2]],
		"/(app)/teams/[id]": [32,[2]],
		"/(app)/users": [34,[2]],
		"/(app)/users/create": [36,[2]],
		"/(app)/users/[id]": [35,[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ kind, error }) => { if (kind === 'unknown') { console.error(error); } }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);